/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import Button from '@atlaskit/button/standard-button';
import Close from '@atlaskit/icon/glyph/editor/close';
import messages from './messages';
import { buttonAutoFocusRingFix } from '../../styles/focus';
export const CancelIconButton = ({
  onCancel,
  tabIndex,
  autoFocus
}) => {
  const {
    formatMessage
  } = useIntl();
  return jsx(Tooltip, {
    content: formatMessage(messages.cancelTooltip),
    position: "top"
  }, jsx(Button, {
    css: buttonAutoFocusRingFix,
    "aria-label": formatMessage(messages.cancelLabel),
    testId: "cancel-icon-button",
    type: "button",
    onClick: onCancel,
    autoFocus: autoFocus,
    iconBefore: jsx(Close, {
      label: formatMessage(messages.cancelTooltip)
    }),
    appearance: "subtle",
    spacing: "compact",
    tabIndex: tabIndex
  }));
};